export const isClientServerVersionComment = (comment) => {
  if (typeof comment !== "string") {
    return false;
  }

  return /\bCS\s*:\s*[\w.-]+/i.test(comment) && /\bSER\s*:\s*[\w.-]+/i.test(comment);
};
